/**
 * Los filtros propios de la columna de la coleccion -CATEGORIA e INGREDIENTE-
 * y el bloque lateral del test. Admite varias casillas a la vez en cada uno.
 *
 * DOS COSAS QUE HACE ESTE FICHERO
 *
 * 1. Mueve los paneles. El marcado NO se genera aqui: lo emite Liquid en
 *    `<template>` dentro del cartel de la coleccion, con las colecciones, los
 *    ingredientes y sus nombres de verdad. Este script solo los lleva a la
 *    columna de filtros. Hace falta porque `sections/main-collection.liquid`
 *    no acepta bloques -renderiza `filters` y `product-card` y nada mas-, asi
 *    que no hay forma de meter contenido propio en esa columna desde el
 *    editor; y el fichero del tema no se toca, que se pierde al actualizar.
 *
 * 2. Filtra. Y lo hace EN LA PAGINA, sin recargar.
 *
 * POR QUE NO SON FILTROS DE SHOPIFY. Para que Shopify filtre por un metacampo
 * hay que declarar el filtro en la app Search & Discovery, y a esa app no se
 * puede entrar por aqui: va en un iframe empotrado y no le llegan ni los
 * clics ni el teclado. Sin declararlo, `?filter.p.m...` devuelve el catalogo
 * entero: esta inerte. Comprobado sirviendo la pagina.
 *
 * POR QUE ESTO SI VALE AQUI. El catalogo son dieciocho referencias y caben
 * todas en una tanda -`products_per_page` esta en 36, el maximo-. Filtrar en
 * el navegador sobre dieciocho tarjetas es instantaneo, admite varias
 * casillas a la vez y no depende de nadie. En un catalogo de mil no valdria.
 *
 * EL ESTADO VIVE EN LA URL, en `?categoria=defensas,descanso&ingrediente=maca`.
 * Asi la seleccion se puede compartir, sobrevive a recargar y al boton de
 * atras, y no hay una segunda copia del estado que pueda desincronizarse.
 *
 * Desde el 12/09/2026 hay dos facetas (la maqueta de coleccion del 11/09 trae
 * el filtro de ingrediente) y desde el 15/09 tres (Caracteristicas, del
 * Figma de la clienta). El mapa guarda HANDLES, no nombres: los mismos de la
 * URL y de las casillas. Un producto se ve si cumple TODAS las facetas con
 * algo marcado, y dentro de cada faceta basta con que cumpla UNA casilla.
 */
(() => {
  // Con el prefijo del idioma (`/pt/`): sin el, en /pt la ruta nunca coincidia
  // y un filtro mandaba al catalogo en castellano.
  const RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const TODOS = `${RAIZ}collections/todos-los-productos`;
  // Los textos, traducidos por snippets/natnatura-textos-js.liquid.
  const T = window.NN_TEXTOS || {};

  /**
   * Cada faceta: el parametro de la URL, la clase de sus filas, el atributo
   * con la clave, y las dos listas del mapa (la de valores y la de producto
   * -> valores). El id de la plantilla y la de la casilla llevan el prefijo.
   */
  const FACETAS = [
    { param: 'categoria', fila: '.nn-categorias__fila', attr: 'data-nn-cat', valores: 'categorias', productos: 'productos', plantilla: 'nn-categorias', prefijo: 'nn-cat-' },
    // Caracteristicas (Figma de la clienta, PRODUCTOS, 15/09/2026): sellos
    // por handle de metaobjeto y capsulas/liquido por el formato.
    { param: 'caracteristica', fila: '.nn-caracteristicas__fila', attr: 'data-nn-car', valores: 'caracteristicas', productos: 'productos_car', plantilla: 'nn-caracteristicas', prefijo: 'nn-car-' },
    { param: 'ingrediente', fila: '.nn-ingredientes__fila', attr: 'data-nn-ing', valores: 'ingredientes', productos: 'productos_ing', plantilla: 'nn-ingredientes', prefijo: 'nn-ing-' },
  ];

  let contador = 0;
  let mapa = null;

  /**
   * La ultima seleccion que ha pedido una persona, por faceta.
   *
   * Existe porque el tema PISA la URL. Cuando se toca un filtro suyo -precio,
   * disponibilidad-, Horizon rehace la direccion a partir de su formulario, y
   * nuestras casillas no estan en ese formulario -van sin `name` a proposito-,
   * asi que los parametros desaparecian y la seleccion se perdia. Se guarda
   * en memoria y no en `sessionStorage`: el filtrado del tema no recarga la
   * pagina, asi que esto sobrevive; y una navegacion de verdad lo borra, que
   * es lo correcto.
   */
  const ultima = {};

  const lee = () => {
    if (mapa) return mapa;
    const nodo = document.getElementById('nn-categorias-mapa');
    if (!nodo) return null;
    try {
      mapa = JSON.parse(nodo.textContent);
    } catch (e) {
      mapa = null;
    }
    return mapa;
  };

  /** Lo marcado en una faceta, leido de la URL. */
  const puestas = (faceta) => {
    const v = new URLSearchParams(window.location.search).get(faceta.param);
    return v ? v.split(',').filter(Boolean) : [];
  };

  /**
   * Lleva cada plantilla a su sitio en las DOS columnas de facetas que hay
   * (la del escritorio y el cajon del movil), con ids unicos por copia: sin
   * eso un `label for=` del cajon activaria la casilla del escritorio.
   */
  const clona = (plantilla, prefijo) => {
    const copia = plantilla.content.cloneNode(true);
    contador += 1;
    copia.querySelectorAll(`input[id^="${prefijo}"]`).forEach((entrada) => {
      const nuevo = `${entrada.id}--${contador}`;
      const etiqueta = copia.querySelector(`label[for="${entrada.id}"]`);
      entrada.id = nuevo;
      if (etiqueta) etiqueta.setAttribute('for', nuevo);
    });
    return copia;
  };

  const coloca = () => {
    document.querySelectorAll('.facets-block-wrapper').forEach((columna) => {
      // El primer panel de facetas marca donde empieza la lista de filtros.
      const primero = columna.querySelector('.facets__panel, accordion-custom, .facets__wrapper');
      if (!primero) return;

      // Las facetas, en orden, delante de las de Horizon.
      FACETAS.forEach((faceta) => {
        if (columna.querySelector(`.${faceta.plantilla}`)) return;
        const plantilla = document.getElementById(faceta.plantilla);
        if (!plantilla) return;
        primero.parentElement.insertBefore(clona(plantilla, faceta.prefijo), primero);
      });

      // El bloque del test, al final de la columna (maqueta del 11/09).
      const lateral = document.getElementById('nn-test-lateral');
      if (lateral && !columna.querySelector('.nn-test-lateral')) {
        primero.parentElement.appendChild(lateral.content.cloneNode(true));
      }

      // COMO EL FIGMA (PRODUCTOS, 15/09/2026): Objetivos cerrado,
      // Caracteristicas e Ingredientes abiertos. Antes (Fran, 12/09) era
      // «solo Categoria abierta». Horizon abre todos los paneles en la
      // disposicion vertical (`open_by_default_on_desktop` en sus snippets,
      // que no se tocan); se ajusta aqui, una vez. Una sola pasada: si el
      // visitante abre o cierra uno, no se le vuelve a tocar.
      if (!columna.dataset.nnPlegado) {
        columna.dataset.nnPlegado = '1';
        columna.querySelectorAll('details.facets__panel').forEach((panel) => {
          panel.open = !panel.closest('.nn-categorias') && !!panel.closest('.nn-caracteristicas, .nn-ingredientes');
        });
      }
    });
  };

  /**
   * Ensena u esconde las tarjetas segun lo que diga la URL, y deja las
   * casillas de acuerdo con ella. Se puede llamar tantas veces como haga
   * falta: solo depende de la URL.
   */
  const aplica = () => {
    const datos = lee();
    const seleccion = {};

    FACETAS.forEach((faceta) => {
      let sel = puestas(faceta);
      // Si el tema se ha llevado el parametro por delante, se repone.
      if (!sel.length && ultima[faceta.param] && ultima[faceta.param].length) {
        sel = ultima[faceta.param].slice();
        const url = new URL(window.location.href);
        url.searchParams.set(faceta.param, sel.join(','));
        window.history.replaceState({}, '', url);
      }
      seleccion[faceta.param] = sel;
      document.querySelectorAll(faceta.fila).forEach((fila) => {
        const casilla = fila.querySelector('input');
        if (!casilla) return;
        const quiere = sel.includes(fila.getAttribute(faceta.attr));
        if (casilla.checked !== quiere) casilla.checked = quiere;
      });
    });

    if (!datos) return;

    let visibles = 0;
    document.querySelectorAll('.product-grid > li').forEach((celda) => {
      const tarjeta = celda.querySelector('[data-product-id]');
      const id = tarjeta && tarjeta.getAttribute('data-product-id');
      const cabe = FACETAS.every((faceta) => {
        const sel = seleccion[faceta.param].filter((h) => (datos[faceta.valores] || []).some((c) => c.handle === h));
        if (!sel.length) return true;
        const suyas = (id && datos[faceta.productos] && datos[faceta.productos][id]) || [];
        return sel.some((h) => suyas.includes(h));
      });
      celda.hidden = !cabe;
      if (cabe) visibles += 1;
    });

    // La cuenta del cartel tiene que decir lo que se ve.
    document.querySelectorAll('.nn-cuenta-linea').forEach((linea) => {
      const molde = visibles === 1 ? (T.productos_uno || '[n] producto') : (T.productos_varios || '[n] productos');
      linea.textContent = molde.replace('[n]', visibles);
    });

    document.querySelectorAll('.nn-categorias-vacio').forEach((aviso) => {
      aviso.hidden = visibles !== 0;
    });
  };

  /** Escribe la seleccion de una faceta en la URL sin recargar, y repinta. */
  const guarda = (faceta, sel) => {
    ultima[faceta.param] = sel.slice();
    const url = new URL(window.location.href);
    if (sel.length) url.searchParams.set(faceta.param, sel.join(','));
    else url.searchParams.delete(faceta.param);
    window.history.replaceState({}, '', url);
    aplica();
  };

  const escucha = () => {
    document.addEventListener('change', (evento) => {
      const casilla = evento.target;
      if (!(casilla instanceof HTMLInputElement)) return;
      const faceta = FACETAS.find((f) => casilla.closest(f.fila));
      if (!faceta) return;
      const fila = casilla.closest(faceta.fila);

      // Que Horizon no vea el cambio: su formulario de filtros recargaria.
      evento.stopPropagation();
      evento.stopImmediatePropagation();
      if (!evento.isTrusted) return;

      const clave = fila.getAttribute(faceta.attr);
      const sel = puestas(faceta).filter((c) => c !== clave);
      if (casilla.checked) sel.push(clave);

      // En `/collections/defensas` la rejilla solo trae los de Defensas, asi
      // que un filtro de aqui solo tiene sentido sobre el catalogo entero.
      if (window.location.pathname !== TODOS) {
        const destino = new URL(TODOS, window.location.origin);
        if (sel.length) destino.searchParams.set(faceta.param, sel.join(','));
        window.location.assign(destino.toString());
        return;
      }
      guarda(faceta, sel);
    }, true);

    // «+ Ver mas» de Ingredientes (Figma): ensena las filas que pasan de la
    // septima y cambia a «− Ver menos».
    document.addEventListener('click', (evento) => {
      const boton = evento.target.closest && evento.target.closest('[data-nn-ver-mas]');
      if (!boton) return;
      const abierto = boton.getAttribute('aria-expanded') === 'true';
      boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      boton.closest('.facets__panel-content').classList.toggle('nn-ingredientes--abierto', !abierto);
      boton.querySelector('.nn-ver-mas__signo').textContent = abierto ? '+' : '\u2212';
      boton.lastChild.textContent = ` ${abierto ? (T.ver_mas || 'Ver más') : (T.ver_menos || 'Ver menos')}`;
    });

    // «Borrar todo» de Horizon limpia tambien lo nuestro.
    document.addEventListener('click', (evento) => {
      const boton = evento.target.closest && evento.target.closest('.facets__clear-all-link');
      if (!boton || !evento.isTrusted) return;
      FACETAS.forEach((faceta) => guarda(faceta, []));
    });

    window.addEventListener('popstate', aplica);
  };

  const inicia = () => {
    coloca();
    aplica();
    escucha();
    // El tema repinta la columna y la rejilla al filtrar por lo suyo: se
    // vuelve a colocar y a aplicar cada poco. Es barato: dieciocho tarjetas.
    window.setInterval(() => {
      coloca();
      aplica();
    }, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicia, { once: true });
  } else {
    inicia();
  }
})();
